module.exports = __webpack_public_path__ + "img/header-profile.4b52f8e1.svg";